import { BackgroundColors } from '@picsart/design-system/foundation/colors';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  {
    section: {
      minWidth: 0,
      gridArea: 'slider',
      [BreakPointsMedia.MD]: {
        padding: 0,
      },
      [BreakPointsMedia.SM]: {
        padding: 0,
      },
      [BreakPointsMedia.XS]: {
        padding: 0,
      },
      [BreakPointsMedia.XXS]: {
        padding: 0,
      },
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s16,
      height: '100%',
    },
    previewWrapper: {
      backgroundColor: BackgroundColors.tint1,
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
    },
    contentWrapper: {
      position: 'relative',
      height: '100%',
    },
    image: {
      borderRadius: CornerRadius.r8,
      objectFit: 'contain',
      maxHeight: '516px',
      maxWidth: '100%',
      height: '100%',
    },
    videoPreview: {
      borderRadius: CornerRadius.r8,
      maxHeight: '516px',
      height: '100%',
    },
    iconWrapper: {
      pointerEvents: 'none',
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      background: BackgroundColors.transparent,
      left: Spacings.s10,
      borderRadius: CornerRadius.r24,
      justifyContent: 'center',
      bottom: Spacings.s10,
      width: Spacings.s40,
      height: Spacings.s32,
    },
    playIcon: {
      width: Spacings.s16,
      height: Spacings.s16,
      fill: BackgroundColors.tint1,
    },
  },
  {
    name: 'slider',
  },
);

export default useStyles;
